import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const IncListList = ({ filterId }) => {
  const augRowsReq = useCallback(EntityUtils.parentFilterAugRowsReq('FILTER', filterId), [filterId]);

  return <EntityList entity="INC_LIST" augRowsReq={augRowsReq} /*augTabButtons={augTabButtons}*/ />;
};
